import React, { useState, useEffect } from "react";
import "./HouseSelectionModal.scss";

//redux imports
import { useSelector } from "react-redux";

const HouseSelectionModal = ({ isOpen, onClose, onSelectHouse }) => {
  const { properties } = useSelector((state) => state.landlordslice);

  const [selectedPropertyId, setSelectedPropertyId] = useState("");
  const [selectedHouseId, setSelectedHouseId] = useState("");
  const [occupiedHouses, setOccupiedHouses] = useState([]);

  useEffect(() => {
    if (properties.length > 0 && !selectedPropertyId) {
      setSelectedPropertyId(properties[0]._id);
    }
  }, [properties]);

  useEffect(() => {
    if (selectedPropertyId) {
      // Find the selected property and get its houses
      const selectedProperty = properties.find(
        (prop) => prop._id === selectedPropertyId
      );

      if (selectedProperty && selectedProperty.houses) {
        // Filter only occupied houses (houses with tenants)
        const occupied = selectedProperty.houses.filter(
          (house) => house.tenant && house.tenant._id && house.status === "occupied"
        );
        setOccupiedHouses(occupied);
      } else {
        setOccupiedHouses([]);
      }
    }
  }, [selectedPropertyId, properties]);

  const handlePropertyChange = (e) => {
    setSelectedPropertyId(e.target.value);
    setSelectedHouseId(""); // Reset house selection when property changes
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedHouseId) {
      alert("Please select a house");
      return;
    }

    const selectedHouse = occupiedHouses.find(
      (house) => house._id === selectedHouseId
    );
    if (selectedHouse) {
      onSelectHouse({
        house_id: selectedHouse._id,
        house_no: selectedHouse.house_no,
        rent: selectedHouse.rent || 0,
        propertyId: selectedPropertyId,
      });
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="house-selection-overlay" onClick={handleOverlayClick}>
      <div className="house-selection-modal">
        <div className="modal-header">
          <h2>Select House for Payment</h2>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="property">Select Property:</label>
            <select
              id="property"
              value={selectedPropertyId}
              onChange={handlePropertyChange}
              required
            >
              <option value="">Choose a property</option>
              {properties.map((property) => (
                <option key={property._id} value={property._id}>
                  {property.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="house">Select House:</label>
            <select
              id="house"
              value={selectedHouseId}
              onChange={(e) => setSelectedHouseId(e.target.value)}
              required
              disabled={!selectedPropertyId || occupiedHouses.length === 0}
            >
              <option value="">Choose a house</option>
              {occupiedHouses.map((house) => (
                <option key={house._id} value={house._id}>
                  House {house.house_no} -{" "}
                  {house.tenant?.user?.name ||
                    `${house.tenant?.firstName} ${house.tenant?.lastName}`}
                </option>
              ))}
            </select>
          </div>

          {occupiedHouses.length === 0 && selectedPropertyId && (
            <p className="no-houses-message">
              No occupied houses found in this property.
            </p>
          )}

          <div className="button-group">
            <button
              type="submit"
              className="select-button"
              disabled={!selectedHouseId}
            >
              Continue to Payment
            </button>
            <button type="button" className="cancel-button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default HouseSelectionModal;

